import { keyframes, styled, Typography } from '@mui/material';

const scroll = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
`;

export const WordsMarquee = styled('section')(({ theme }) => ({
  position: 'relative',
  width: '100%',
  overflow: 'hidden',
  paddingBottom: '170px',

  [theme.breakpoints.down('2xl')]: {
    paddingBottom: '140px',
  },
  [theme.breakpoints.down('xl')]: {
    paddingBottom: '112px',
  },
  [theme.breakpoints.down('lg')]: {
    paddingBottom: '96px',
  },
  [theme.breakpoints.down('md')]: {
    paddingBottom: '72px',
  },
  [theme.breakpoints.down('sm')]: {
    paddingBottom: '64px',
  },
}));

export const Viewport = styled('div')(() => ({
  width: '100%',
  overflow: 'hidden',

  '&:hover .marquee-track': {
    animationPlayState: 'paused',
  },
}));

export const Track = styled('div')(({ theme }) => ({
  display: 'flex',
  width: 'max-content',
  animation: `${scroll} 45s linear infinite`,
  willChange: 'transform',

  [theme.breakpoints.down('lg')]: {
    animationDuration: '35s',
  },
  [theme.breakpoints.down('sm')]: {
    animationDuration: '28s',
  },
}));

export const Group = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  gap: '96px',
  paddingRight: '96px',

  [theme.breakpoints.down('xl')]: {
    gap: '72px',
    paddingRight: '72px',
  },
  [theme.breakpoints.down('lg')]: {
    gap: '64px',
    paddingRight: '64px',
  },
  [theme.breakpoints.down('md')]: {
    gap: '48px',
    paddingRight: '48px',
  },
  [theme.breakpoints.down('sm')]: {
    gap: '32px',
    paddingRight: '32px',
  },
}));

export const Item = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  gap: '96px',

  [theme.breakpoints.down('xl')]: {
    gap: '72px',
  },
  [theme.breakpoints.down('lg')]: {
    gap: '64px',
  },
  [theme.breakpoints.down('md')]: {
    gap: '48px',
  },
  [theme.breakpoints.down('sm')]: {
    gap: '32px',
  },
}));

export const Word = styled(Typography)(() => ({
  whiteSpace: 'nowrap',
}));

export const Logo = styled('img')(({ theme }) => ({
  flexShrink: 0,
  width: '44px',

  [theme.breakpoints.down('xl')]: {
    width: '36px',
  },
  [theme.breakpoints.down('lg')]: {
    width: '28px',
  },
}));
